import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { AdjustmentTypeStore } from '../service/adjustment-type/adjustment-type.store';
import { Observable } from 'rxjs/Observable';
import { AdjustmentType } from '../models/adjustment-type';

@Injectable()
export class AdjustmentTypeCreditResolver implements Resolve<AdjustmentType[]> {

  constructor(private adjustmentTypeStore: AdjustmentTypeStore) { }

  resolve(): Observable<AdjustmentType[]> {
    return this.adjustmentTypeStore.loadCreditAdjustmentTypes();
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/payment/adjustment-type-credit.resolver.ts